"use client";
import { IComponent } from "@/interfaces";
import { useEffect, useRef } from "react";

const initialPositionDeg = 250;

const getDegs = (rads: number, deltaX: number, deltaY: number) => {
  const degs = (rads * 180) / Math.PI;
  if (deltaX > 0 && deltaY > 0) return -degs;
  if (deltaX < 0 && deltaY > 0) return degs;
  if (deltaY < 0 && deltaX > 0) {
    return -(180 - degs);
  }
  return 180 - degs;
};

export const CatLight: IComponent<{ isLeft?: true }> = ({ isLeft }) => {
  const lightRef = useRef<HTMLDivElement>(null);
  const baseRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const calculateLight = (mouseX: number, mouseY: number) => {
      if (window.innerWidth < 650) return;
      if (!lightRef.current || !baseRef.current) return;
      const bounds = baseRef.current.getBoundingClientRect();
      const eyeX = bounds.x + (isLeft ? 25 : -25);
      const eyeY = bounds.y;
      const deltaX = mouseX - eyeX;
      const deltaY = mouseY - eyeY;

      const degs = getDegs(Math.atan(deltaX / deltaY), deltaX, deltaY);

      const value = -degs;

      if (value < 270 && value > 180) {
        lightRef.current.style.transition = "none";
        lightRef.current.style.transform = `rotate(${value}deg)`;
      } else if (value > -180 && value < -90) {
        lightRef.current.style.transition = "none";
        lightRef.current.style.transform = `rotate(${-value}deg)`;
      } else {
        lightRef.current.style.transition = "200ms ease-in";
        lightRef.current.style.transform = `rotate(${initialPositionDeg}deg)`;
      }
    };

    const onMouseMove = (e: MouseEvent) => {
      requestAnimationFrame(() => calculateLight(e.clientX, e.clientY));
    };

    const onTouch = (e: TouchEvent) => {
      calculateLight(e.touches[0].clientX, e.touches[0].clientY);
    };

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("touchstart", onTouch);

    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("touchstart", onTouch);
    };
  }, []);

  return (
    <div
      className="cat-light-container "
      ref={baseRef}
    >
      <div
        className="cat-light invisible md:visible rotate-0 duration-100 linear"
        ref={lightRef}
      />
    </div>
  );
};
